import * as firebase from 'firebase';
import { RECEIVED_BRAND_DATA, UPDATE_DATA, NEW_SIMULATION, EXIT_SIMULATION, LOAD_SIMULATION, GET_SAVED_SIMULATIONS, RECEIVE_RELEVANCE_DATA, SET_RELEVANCE_GROUP, RECEIVE_VARIABLE_DATA, DID_REQUEST_INITIAL_DATA, SET_START_DATE, SET_END_DATE, TOGGLE_TIMELINE_ACTIVE, INIT_TELESCOPE, RECEIVED_TELESCOPE_DATA, SET_AVAILABLE_DATES, TOGGLE_RELEVANCE_CHART, RECEIVED_BRAND_AWARENESS_DATA, RECEIVED_AD_AWARENESS_DATA, RECEIVED_BRAND_CONSIDERATION_DATA, UPDATE_WASHED_SENTIMENT_DATA, GET_CLIENTS } from '../actionTypes';
import { dbSimulations } from '../firebase';
import { dbClient } from '../firebase';
import { auth } from '../firebase';
import moment from 'moment';
import _ from 'lodash';
import {formatPData} from "../helpers/dataHelpers";

export function receivedBrandAwarenessData(data) {
  return (dispatch, getState) => {
    dispatch({
      type: RECEIVED_BRAND_AWARENESS_DATA,
      payload: data
    });
  };
};

export function receivedAdAwarenessData(data) {
  return (dispatch, getState) => {
    dispatch({
      type: RECEIVED_AD_AWARENESS_DATA,
      payload: data
    });
  };
};

export function receivedBrandConsiderationData(data) {
  return (dispatch, getState) => {
    dispatch({
      type: RECEIVED_BRAND_CONSIDERATION_DATA,
      payload: data
    });
  };
};


export function switchClient(client) {
  firebase.database().ref('/userProfile/' + auth.currentUser.uid).update({
      client:client
    }, function(error) {
      if (error) {
        console.log("err: " + error);
      } else {
        const endDate = new Date();
        setEndDate(endDate);
        window.location.reload();
      }
    });

    return dispatch => function() {
  }
}

export function updateTargetSettings(targetSettings) {
  return (dispatch, getState) => {
    firebase.database().ref('/clients/' + getState().user.userProfile.client).update({
        targetSettings:targetSettings
      }, function(error) {
        if (error) {
          console.log("err: " + error);
        } else {

        }
      });
      return dispatch => function() {
    }
  }
}

export function toggleDigitalFootprint(val) {
  return (dispatch, getState) => {
    firebase.database().ref('/clients/' + getState().user.userProfile.client).update({
        digitalFootprint: val
      }, function(error) {
        if (error) {
          console.log("err: " + error);
        } else {
          console.log("success");
        }
      });
      return dispatch => function() {
    }
  }
}

export function updateRawData(rawData) {
  return (dispatch, getState) => {
    firebase.database().ref('/clients/' + getState().user.userProfile.client).update({
        rawData:rawData
      }, function(error) {
        if (error) {
          console.log("err: " + error);
        } else {
          console.log("success");
        }
      });
      return dispatch => function() {
    }
  }
}


export function updateSentimentSettings(sentimentSettings) {
  return (dispatch, getState) => {
    firebase.database().ref('/clients/' + getState().user.userProfile.client).update({
        sentimentSettings:sentimentSettings
      }, function(error) {
        if (error) {
          console.log("err: " + error);
        } else {
          console.log("success");
        }
      });
      return dispatch => function() {
    }
  }
}


export function updateWordCloudSettings(wordCloudSettings) {
  return (dispatch, getState) => {
    firebase.database().ref('/clients/' + getState().user.userProfile.client).update({
        wordCloudSettings:wordCloudSettings
      }, function(error) {
        if (error) {
          console.log("err: " + error);
        } else {
          console.log("success");
        }
      });
      return dispatch => function() {
    }
  }
}

export function updateIndustryThemeSettings(industryThemeSettings) {
  return (dispatch, getState) => {
    firebase.database().ref('/clients/' + getState().user.userProfile.client).update({
        industryThemeSettings:industryThemeSettings
      }, function(error) {
        if (error) {
          console.log("err: " + error);
        } else {
          console.log("success");
        }
      });
      return dispatch => function() {
    }
  }
}

const buildSimulation = async function(simulatedParams, data, telescope, endDate) {
  const variables = [
    {apiId:'price', modelId:'prc'},
    {apiId:'product', modelId:'prd'},
    {apiId:'place', modelId:'plc'},
    {apiId:'promotion', modelId:'prm'},
    {apiId:'proposal', modelId:'prp'},
    {apiId:'people', modelId:'ppl'},
    {apiId:'preference', modelId:'prf'},
    {apiId:'total', modelId:'rlv'}
  ];

  let currentDataPoints = data ? data.variables : [];
  let dataset = {};
  variables.forEach(function(v, i) {
    currentDataPoints.forEach(function(dp,j) {
      if (dp.id === v.apiId) {
        variables[i].score = dp.score;
      };
    });

    if (simulatedParams[v.apiId] && simulatedParams[v.apiId].active) {
      dataset[v.modelId] = simulatedParams[v.apiId].sliderValue;
    }
  });

  if (Object.keys(dataset).length === 0 || (Object.keys(dataset).length === 1 && dataset['rlv'])) {
    return simulatedParams;
  };

  const ts = telescope;
  const formattedDate = moment(endDate).format("YYYY-MM-DD");
  ts.date = moment(endDate).format(formattedDate);
  await ts._load() // convenient way to wait for updates from ts.date = ..

  let resultScores = ts.predict(dataset)
  const predictions = resultScores;

  let output = simulatedParams;

  variables.forEach(function(v, k) {
    output[v.apiId] = output[v.apiId] ? output[v.apiId] : {};
    output[v.apiId].generatedDeltaValue = predictions[v.modelId];
    output[v.apiId].generatedScore = predictions[v.modelId]; // Switch back to actual return value
  });

  return output;
};


/* NEW DATA API */
export function receivedBrandData(brand, data) {
  const _data = {
    brand: brand,
    data: data
  }
  return dispatch => {
    dispatch({
      type: RECEIVED_BRAND_DATA,
      payload: _data
    });
  };
};

export function initTelescopeData(telescope) {
  return dispatch => {

    dispatch(updateWashedSentimentData());
    dispatch({
      type: INIT_TELESCOPE,
      payload: telescope
    });
  };
};

export function receivedTelescopeData(data) {
  return (dispatch, getState) => {
    if (!data.rlv || !data.rlv.score) {
      return false;
    }
    let _data = formatPData(data, getState())

    dispatch({
      type: RECEIVED_TELESCOPE_DATA,
      payload: _data
    });
  };
};


/* -------------- */
/* RELEVANCE DATA */
/* -------------- */

export function didRequestInitialData() {
  return {
    type: DID_REQUEST_INITIAL_DATA,
    payload: true
  }
}

export function receiveVariableData(json) {
  let data = json.data;
  if (typeof data === 'string' || data instanceof String) {
    data = JSON.parse(data);
  }
  return {
    type: RECEIVE_VARIABLE_DATA,
    payload: {
      data: data,
      receivedAt: Date.now()
    }
  }
}

export function setRelevanceGroup(group) {
  return (dispatch, getState) => {
    dispatch({
        type: SET_RELEVANCE_GROUP,
        payload: group
    });

    getState().data.telescope.scores({"start": getState().data.startDate, "end": getState().data.endDate, "group":group}).then(data => {
      data.group=group;

      dispatch({
        type: RECEIVE_RELEVANCE_DATA,
        payload: data
      });
    });
  };
};

export function updateData(data) {
  return (dispatch, getState) =>
  {
    let simulationParams = getState().data.simulationParams ? getState().data.simulationParams : {};
    simulationParams[data.id] = {score:data.score, deltaScore: data.deltaScore, sliderValue: data.sliderValue, active: data.active};

    buildSimulation(simulationParams, getState().data.variableData, getState().data.telescope, getState().data.endDate).then(simulationParamsOut => {
      dispatch({
        type: UPDATE_DATA,
        payload: simulationParamsOut
      });
    });
  }
}

export function newSimulation(data) {
  return { type: NEW_SIMULATION, payload: true}
}

export function loadSimulation(data) {
  return { type: LOAD_SIMULATION, payload: data}
}

export function exitSimulation(data) {
  return { type: EXIT_SIMULATION, payload: false}
}


export function deleteSimulation(id) {
  return dispatch => dbSimulations.child(id).remove();
}

export function saveSimulation(data) {
  return dispatch => dbSimulations.push(data, function(error) {
    if (error)
      console.log('Error has occured during saving process')
    else
      console.log("Data has been saved succesfully")
  });
}

export function getSavedSimulations() {
  return dispatch => {
    dbSimulations.orderByChild("userId").equalTo(auth.currentUser.uid).on(
      'value',
      snapshot => {
        dispatch({
          type: GET_SAVED_SIMULATIONS,
          payload: snapshot.val()
        });
      }
    );
  };
};

export function getClientList() {
  return dispatch => {
    dbClient.on(
      'value',
      snapshot => {
        dispatch({
          type: GET_CLIENTS,
          payload: snapshot.val()
        });
      }
    );
  };
};



export function updateTimesSeries(startDate, endDate, group) {
  return (dispatch, getState) => {

    getState().data.telescope.scores({"start":startDate, "end": endDate, "group":group, includeIndex: true}).then(data => {
      data.group=group;
      dispatch({
        type: RECEIVE_RELEVANCE_DATA,
        payload: data
      });
    });

    getState().data.telescope.timeSeries('yougov.brand.awareness',{start: startDate,end: endDate, group: 'month'}).then((data) => {
      dispatch({
        type: RECEIVED_BRAND_AWARENESS_DATA,
        payload: data
      });
    });

    getState().data.telescope.timeSeries('yougov.brand.consideration',{start: startDate,end: endDate, group: 'month'}).then((data) => {
      dispatch({
        type: RECEIVED_BRAND_CONSIDERATION_DATA,
        payload: data
      });
    });

    getState().data.telescope.timeSeries('yougov.prm.ad_awareness',{start: startDate,end: endDate, group: 'month'}).then((data) => {
      dispatch({
        type: RECEIVED_AD_AWARENESS_DATA,
        payload: data
      });
    });

    getState().data.telescope.timeSeries('index.brand.sov.brands',{start: startDate,end: endDate, group: 'month'}).then((data) => {
      dispatch({
        type: 'RECEIVED_SOV_DATA',
        payload: data
      });
    });

  }
}

export function updateWashedSentimentData(startDate, endDate, group) {
  return (dispatch, getState) => {

    const sentimentSettings = getState().user.client && getState().user.client.sentimentSettings;

    let words = [];
    _.each(sentimentSettings, function(row, i) {
      let word = {};
      _.each(row, function(col,i) {
        word[col.type] = col.value
      });
      words.push(word);
    })

    dispatch({
      type: UPDATE_WASHED_SENTIMENT_DATA,
      payload: words
    });
  }
}


export function setStartDate(data) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_START_DATE,
      payload: data
    });

    const startDate = moment(data).format("YYYY-MM-DD");
    const endDate = moment(getState().data.endDate).format("YYYY-MM-DD");
    const group = getState().data.relevanceGroup || 'month';

    dispatch(updateTimesSeries(startDate, endDate, group));
  };
}

export function setEndDate(data) {
  return (dispatch, getState) => {
    dispatch({
        type: SET_END_DATE,
        payload: data
    });

    const startDate = moment(getState().data.startDate).format("YYYY-MM-DD");
    const endDate = moment(data).format("YYYY-MM-DD");
    const group = getState().data.relevanceGroup || 'month';

    dispatch(updateTimesSeries(startDate, endDate, group));

    getState().data.telescope.date = endDate;
  };
}

export function setAvailableDates(data) {
  return {
    type: SET_AVAILABLE_DATES,
    payload: data
  }
}

export function toggleTimelineActive(active) {
  return { type: TOGGLE_TIMELINE_ACTIVE, payload: active}
}

export function toggleRelevanceChart(active) {
  return { type: TOGGLE_RELEVANCE_CHART, payload: active}
}



// WEBPACK FOOTER //
// ./src/actions/dataAction.js